import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';

import { getCampaignCreationMethod, CampaignCreationMethod } from './components/campaign-creation-method-constants';
import { CampaignCreationMethodSelectionStyles } from './styles/campaign-creation-method-item-styles';
import { CampaignCreationMethodItem } from './components/campaign-creation-method-item';

export function CampaignCreationMethodSelection(props) {
  const {
    i18n,

    onClickCreateNewCampaign,
    onClickGoogleImport,
    onClickFacebookImport,

    isVertical,
    disableImports,
    isRebranding,

    selectedItem,
  } = props;

  const campaignCreationMethods = useMemo(() => getCampaignCreationMethod(disableImports, isVertical, isRebranding), [disableImports, isVertical, isRebranding]);
  const onMethodItemClick = useCallback((selection) => {
    if (selection === CampaignCreationMethod.GOOGLE_IMPORT) {
      onClickGoogleImport();
    } else if (selection === CampaignCreationMethod.FACEBOOK_IMPORT) {
      onClickFacebookImport();
    } else {
      onClickCreateNewCampaign();
    }
  }, [onClickCreateNewCampaign, onClickFacebookImport, onClickGoogleImport]);

  const renderSelectionItem = useMemo(() => _.map(campaignCreationMethods, (item, itemIndex) => (
    <CampaignCreationMethodItem
      i18n={i18n}
      itemIndex={itemIndex}
      onMethodItemClick={onMethodItemClick}
      shouldForceContentInTwoLines={item.forceContentInTwoLines}
      method={item.method}
      imageSrc={item.imageSrc}
      content={item.content}
      alt={item.alt}
      label={item.label}
      isVertical={isVertical}
      disabled={item.disabled}
      disableText={item.disableText}
      selected={selectedItem === item.method}
    />
  )), [campaignCreationMethods, i18n, isVertical, onMethodItemClick, selectedItem]);

  return (
    <div className="campaign-creation-method-selection">
      <Stack
        horizontal={!isVertical}
        disableShrink
        tokens={isVertical ? CampaignCreationMethodSelectionStyles.itemContainerVerticalTokens : CampaignCreationMethodSelectionStyles.itemContainerTokens}
        aria-label={i18n.getString(_TL_('campaign creation method options'))}
        role="listbox"
      >
        {renderSelectionItem}
      </Stack>
    </div>
  );
}

CampaignCreationMethodSelection.propTypes = {
  i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }),

  onClickCreateNewCampaign: PropTypes.func.isRequired,
  onClickGoogleImport: PropTypes.func.isRequired,
  onClickFacebookImport: PropTypes.func.isRequired,

  isVertical: PropTypes.bool,
  disableImports: PropTypes.bool,
  isRebranding: PropTypes.bool,

  selectedItem: PropTypes.string,
};

CampaignCreationMethodSelection.defaultProps = {
  i18n: { getString: value => value },
  isVertical: false,
  disableImports: false,
  isRebranding: false,
  selectedItem: '',
};
